<script setup lang="ts">
import { ref, watch } from 'vue';
import {
  DxDataGrid,
  DxColumn,
  DxSorting,
  DxScrolling,
} from 'devextreme-vue/data-grid';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { BottoPagePanel, JsonEditor, bottoGridPaging } from '@botto/core';
import CdpPageShell from '../components/CdpPageShell.vue';
import {
  scheduleActionsStore,
  scheduleActionStatusLabel,
  type ScheduleAction,
} from '../api';
import { useCdpProjectContext } from '../composables/useCdpProjectContext';

const { paging, pager } = bottoGridPaging();

const { hasProject, selectedProjectId } = useCdpProjectContext();

const grid = ref<InstanceType<typeof DxDataGrid> | null>(null);
const detailOpen = ref(false);
const detailRow = ref<ScheduleAction | null>(null);

function statusCell(row: ScheduleAction): string {
  return scheduleActionStatusLabel(row);
}

function openDetail(e: { data: ScheduleAction }) {
  detailRow.value = e.data;
  detailOpen.value = true;
}

watch(selectedProjectId, () => {
  if (hasProject.value) grid.value?.instance?.refresh();
});
</script>

<template>
  <CdpPageShell title="Retention">
    <BottoPagePanel>
      <DxDataGrid
        ref="grid"
        :data-source="scheduleActionsStore"
        :remote-operations="true"
        :show-borders="false"
        :show-row-lines="false"
        :show-column-lines="false"
        :row-alternation-enabled="true"
        :column-auto-width="true"
        :hover-state-enabled="true"
        :paging="paging"
        :pager="pager"
        height="100%"
        width="100%"
        @row-click="openDetail"
      >
        <DxScrolling mode="standard" />
        <DxSorting mode="single" />

        <DxColumn
          caption="Статус"
          :calculate-cell-value="statusCell"
          :allow-sorting="false"
          width="200"
        />
        <DxColumn data-field="schedule_execution" caption="Запуск" data-type="datetime" width="180" />
        <DxColumn data-field="phone" caption="Телефон" />
        <DxColumn data-field="src_goal" caption="Src goal" width="120" />
        <DxColumn data-field="dst_goal" caption="Dst goal" width="120" />
        <DxColumn data-field="task" caption="Task" width="100" />
        <DxColumn data-field="order" caption="Шаг" width="70" />
        <DxColumn data-field="success" caption="OK" data-type="boolean" width="60" />
        <DxColumn data-field="attempts" caption="Попытки" width="80" />
        <DxColumn data-field="result" caption="Результат" />
      </DxDataGrid>
    </BottoPagePanel>

    <DxPopup
      v-model:visible="detailOpen"
      title="Schedule action"
      :width="720"
      :height="560"
      :show-close-button="true"
    >
      <template #content>
        <JsonEditor v-if="detailRow" :model-value="detailRow" height="460px" readonly />
      </template>
      <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="{ text: 'Закрыть', onClick: () => (detailOpen = false) }" />
    </DxPopup>
  </CdpPageShell>
</template>
